import React from 'react'

const BadRequestSimple = () => {
  return (
    <div data-testid="complaint-badrequestsimple">
      <h2>Sorry!</h2>
      <p>
        There was an error submitting your complaint. You can try again at a
        later time.
      </p>
    </div>
  )
}

export default BadRequestSimple
